import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, MousePointerClickIcon, PieChartIcon, TrendingUpIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid4Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2273">
      <SEO title="Norden, Ads & Data Specialist | Noord Digital" description="Maak kennis met Norden, Ads & Data Specialist bij Noord Digital. Expert in Google Ads, data-analyse en conversie optimalisatie voor B2B bedrijven." keywords="norden noord digital, ads specialist, data specialist, google ads expert, conversie optimalisatie, b2b marketing" canonical="https://noorddigital.nl/over-ons/norden" data-id="element-2274" />
      <Header data-id="element-2275" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2276">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2277">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2278">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2279" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2280">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2281">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] bg-[#EEF5FA] flex items-center justify-center shadow-lg overflow-hidden" data-id="element-2282">
                <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden" className="w-full h-full object-cover" data-id="element-2283" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2284">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2285">
                Norden
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2286">
                Ads & Data Specialist
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2287">
                <p className="mb-4" data-id="element-2288">
                  Als Ads & Data Specialist zorg ik ervoor dat elke
                  geïnvesteerde euro in advertenties maximaal rendement
                  oplevert. Ik beheer de Google Ads-campagnes binnen de
                  CorePrint methode en stuur scherp op data en conversies.
                </p>
                <p className="mb-4" data-id="element-2289">
                  Ik geloof niet in 'set and forget'. Campagnes vereisen
                  continue monitoring, A/B-testen en optimalisatie. Door data
                  nauwkeurig te analyseren, ontdek ik patronen en kansen die
                  anderen over het hoofd zien.
                </p>
                <p data-id="element-2290">
                  Mijn aanpak is altijd resultaatgericht. Of het nu gaat om het
                  verlagen van de kosten per lead (CPA) of het verhogen van de
                  Return on Ad Spend (ROAS), ik zorg dat de cijfers kloppen en
                  de doelstellingen worden behaald.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2291">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2292">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2293">
                  <MousePointerClickIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2294" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2295">Google Ads</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2296">
                  <PieChartIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2297" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2298">Data-analyse</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2299">
                  <TrendingUpIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2300" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2301">
                    Conversion Optimalisatie
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2302">
                Neem contact op met Norden
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2303" />
    </div>;
};